<template>
  <v-main class="default-layout">
    <slot></slot>
  </v-main>
</template>

<script>
export default {
  name: 'DefaultLayout'
}
</script>
